import React from 'react';

interface IconProfileProps {
  className?: string;
  size?: number;
  color?: string;
}

export const IconProfile: React.FC<IconProfileProps> = ({ className = '', size = 17, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.28383 4.66L9.83316 3.11133C10.3046 2.63987 10.9441 2.375 11.6108 2.375C11.941 2.375 12.2679 2.44003 12.5729 2.56637C12.8779 2.69271 13.155 2.87789 13.3885 3.11133C13.6219 3.34478 13.8071 3.62192 13.9335 3.92693C14.0598 4.23195 14.1248 4.55886 14.1248 4.889C14.1248 5.21914 14.0598 5.54605 13.9335 5.85107C13.8071 6.15608 13.6219 6.43322 13.3885 6.66667L11.8398 8.216M5.15983 7.78467L3.6105 9.33333C3.13894 9.80489 2.87402 10.4445 2.87402 11.1113C2.87402 11.7782 3.13894 12.4178 3.6105 12.8893C4.08205 13.3609 4.72162 13.6258 5.3885 13.6258C6.05537 13.6258 6.69494 13.3609 7.1665 12.8893L8.71516 11.34M9.83183 6.66667L7.16516 9.33333"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default IconProfile;
